import { StrictMode } from "react";
import { App } from "./App";

export function AppRoot() {
  return (
    <StrictMode>
      <App />
    </StrictMode>
  );
}
